import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import 'features/setting/treatment-plans/treatment-plan-types/style.css'

/** API */
import TreatmentPlanTypeApi from 'api/setting/treatment-plans/treatment-plan-type.api'

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableRowExport from 'component/Pdf/TableRowExport'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { dateTimeToView } from 'utils/date.utils'
import { exportPlanTypeToExcel } from './exportPlanTypeToExcel'

const initStateErrorMessage = {
  TREATMENT_PLAN_TYPE_NAME: ``,
  IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME: ``,
  TREATMENT_PLAN_TYPE_NAME_STRING_BASE: ``,
  TREATMENT_PLAN_TYPE_NAME_STRING_EMPTY: ``,
  TREATMENT_PLAN_TYPE_NAME_MAXIMUM_LENGTH: ``,
  TREATMENT_PLAN_TYPE_NAME_ANY_REQUIRED: ``,

  TREATMENT_PLAN_TYPE_NAME_EN: ``,
  IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME_EN: ``,
  TREATMENT_PLAN_TYPE_NAME_EN_STRING_BASE: ``,
  TREATMENT_PLAN_TYPE_NAME_EN_STRING_EMPTY: ``,
  TREATMENT_PLAN_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  TREATMENT_PLAN_TYPE_NAME_EN_ANY_REQUIRED: ``
}
export default function TreatmentPlanTypes() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const componentRef = useRef<any>(null)
  const [treatmentPlanTypes, setTreatmentPlanTypes] = useState([])
  const [exportData, setExportData] = useState([])

  const [treatmentPlanTypeId, setTreatmentPlanTypeId] = useState(Number)
  const [treatmentPlanTypeName, setTreatmentPlanTypeName] = useState('')
  const [treatmentPlanTypeNameEn, setTreatmentPlanTypeNameEn] = useState('')
  const [treatmentPlanTypeStatus, setTreatmentPlanTypeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const loadData = async () => {
    try {

      let condition = {}
      condition = {
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      }
      const resp = await TreatmentPlanTypeApi.findAll(condition)
      const respExport = await TreatmentPlanTypeApi.findAll({ ...condition, export: 1 })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setTreatmentPlanTypes(resp.data)
        setExportData(respExport.data)
      } else {
        setTreatmentPlanTypes([])
        setExportData([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    setDisabledSubmit(true)
    if (!treatmentPlanTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ TREATMENT_PLAN_TYPE_NAME: t('TREATMENT_PLAN_TYPE.MESSAGE.TREATMENT_PLAN_TYPE_NAME') } })
    }

    dispatch(submitModal())
    TreatmentPlanTypeApi.create({ treatmentPlanTypeName, treatmentPlanTypeNameEn })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('TREATMENT_PLAN_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!treatmentPlanTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ TREATMENT_PLAN_TYPE_NAME: t(`TREATMENT_PLAN_TYPE.MESSAGE.TREATMENT_PLAN_TYPE_NAME`) } })
    }

    dispatch(submitModal())
    TreatmentPlanTypeApi.update(treatmentPlanTypeId, {
      treatmentPlanTypeName,
      treatmentPlanTypeNameEn,
      status: treatmentPlanTypeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`TREATMENT_PLAN_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setTreatmentPlanTypeId(0)
    setTreatmentPlanTypeName('')
    setTreatmentPlanTypeNameEn('')
    setTreatmentPlanTypeStatus('')
    clearErrorMessage()
    setIsOpen(false)
  }

  const onActive = () => {
    if (id) {
      TreatmentPlanTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_PLAN_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_PLAN_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      TreatmentPlanTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_PLAN_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_PLAN_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { treatmentPlanTypeId: txPlanTypeId, treatmentPlanTypeName: txPlanTypeName, treatmentPlanTypeNameEn: txPlanTypeNameEn, status: txPlanTypeStatus } = data
    setTreatmentPlanTypeId(txPlanTypeId)
    setTreatmentPlanTypeName(txPlanTypeName)
    setTreatmentPlanTypeNameEn(txPlanTypeNameEn)
    setTreatmentPlanTypeStatus(txPlanTypeStatus)
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'treatmentPlanTypeName', disablePadding: false, label: t('TREATMENT_PLAN_TYPE.TABLE.CELL.TREATMENT_PLAN_TYPE_NAME') },
    { id: 'treatmentPlanTypeNameEn', disablePadding: false, label: t('TREATMENT_PLAN_TYPE.TABLE.CELL.TREATMENT_PLAN_TYPE_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('TREATMENT_PLAN_TYPE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('TREATMENT_PLAN_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number, valueExportData: boolean) => {
    const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
    const { treatmentPlanTypeId: txPlanTypeId, treatmentPlanTypeName: txPlanTypeName, treatmentPlanTypeNameEn: txPlanTypeNameEn, updatedBy, updatedAt, status: txPlanTypeStatus } = objData
    const statusBtnActive = txPlanTypeStatus === 'ACTIVE' ? true : false
    const statusBtnInActive = txPlanTypeStatus === 'INACTIVE' ? true : false
    const objRenderData = {
      key: txPlanTypeId,
      id: txPlanTypeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: num },
        { option: 'TEXT', align: 'left', label: txPlanTypeName || "-" },
        { option: 'TEXT', align: 'left', label: txPlanTypeNameEn || "-" },
        { option: 'STATUS', align: 'center', label: txPlanTypeStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: false },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: false }
          ]
        }
      ]
    }
    return (
      <>
        {valueExportData === true && <TableRowExport {...objRenderData} /> ||
          <TableRowCommon
            {...objRenderData}
            onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
            oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            onedit={() => onEdit(objRenderData.obj)}
            ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
          />
        }
      </>
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.treatmentPlanTypeName)
    setNameEn(obj.treatmentPlanTypeNameEn)
  }

  const filter = [
    { label: `${t('INPUT.SEARCH')}: ${search || '-'}` },
    { label: `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}` }
  ]

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`TREATMENT_PLAN_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`TREATMENT_PLAN_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { treatmentPlanTypeName: name, treatmentPlanTypeNameEn: nameEn && `(${nameEn})`, status: t(`TREATMENT_PLAN_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />

      <PageModal
        title={treatmentPlanTypeId ? t('TREATMENT_PLAN_TYPE.TITLE_UPDATE') : t('TREATMENT_PLAN_TYPE.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('TREATMENT_PLAN_TYPE.BUTTON.CANCEL') }}
        onSubmit={{ onClick: treatmentPlanTypeId ? submitEdit : submit, title: t('TREATMENT_PLAN_TYPE.BUTTON.SAVE'), disabled: disabledSubmit }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          {treatmentPlanTypeId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setTreatmentPlanTypeStatus(treatmentPlanTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={treatmentPlanTypeStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              setTreatmentPlanTypeName(event.target.value)
              clearErrorMessage()
            }}
            value={treatmentPlanTypeName}
            label={t('TREATMENT_PLAN_TYPE.INPUT.TREATMENT_PLAN_TYPE_NAME')}
            helperText={
              errorMessage.TREATMENT_PLAN_TYPE_NAME ||
              errorMessage.IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_STRING_BASE ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_STRING_EMPTY ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_MAXIMUM_LENGTH ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_ANY_REQUIRED
            }
            required
          />
          <TextInput
            onChange={(event) => {
              setTreatmentPlanTypeNameEn(event.target.value)
              clearErrorMessage()
            }}
            value={treatmentPlanTypeNameEn}
            helperText={
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN ||
              errorMessage.IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME_EN ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_STRING_BASE ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_STRING_EMPTY ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_MAXIMUM_LENGTH ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_ANY_REQUIRED
            }
            label={t('TREATMENT_PLAN_TYPE.INPUT.TREATMENT_PLAN_TYPE_NAME_EN')}
          />
        </Box>
      </PageModal>
      <HeaderCard text={t('TREATMENT_PLAN_TYPE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('TREATMENT_PLAN_TYPE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />

              <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                  if (e === 'Excel') {
                    const report: any = {
                      title: t('TREATMENT_PLAN_TYPE.TITLE'),
                      statusFilter: filter[1].label,
                      rows: exportData.map((item: any) => ({
                        treatmentPlanTypeName: item?.treatmentPlanTypeName || '-',
                        treatmentPlanTypeNameEn: item?.treatmentPlanTypeNameEn || '-',
                        status: t(`STATUS.${item?.status}`),
                        updatedBy: item?.updatedBy,
                        updatedAt: dateTimeToView(item?.updatedAt)
                      })),
                      t
                    }
                    exportPlanTypeToExcel(report)
                  } else if (e === 'PDF') {
                    const style = document.createElement("style");
                    style.innerHTML = `
                      @media print {
                        @page { size: portrait }
                      }
                    `;
                    document.head.appendChild(style);
                    window.print();
                    document.head.removeChild(style);

                  }
                }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
                <MainButton title={t('TREATMENT_PLAN_TYPE.BUTTON.ADD')} type='primary' variant='contained' onClick={() => setIsOpen(true)} startIcon={<AddCircleIcon />} />
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={treatmentPlanTypes.map((val, i) => {
              return renderData(val, i, false)
            })}
          />

          <Box
            id="print-table-container"
            ref={componentRef}
          >
            <Typography fontSize="14px" fontWeight={400}>{t('TREATMENT_PLAN_TYPE.TITLE')}</Typography>
            <Box display='flex' flexDirection="row" alignItems="center" gap="16px">
              <Typography fontSize="10px" fontWeight={400}>{t('STATUS.LABEL')}: {status === 'ALL' ? t('STATUS.ALL') : status === 'ACTIVE' ? t('STATUS.ACTIVE') : t('STATUS.INACTIVE')}</Typography>
            </Box>
            <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
              <thead>
                <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                  <th style={{ borderBottom: '1px solid black' }}>{t('#')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('TREATMENT_PLAN_TYPE.TABLE.CELL.TREATMENT_PLAN_TYPE_NAME')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('TREATMENT_PLAN_TYPE.TABLE.CELL.TREATMENT_PLAN_TYPE_NAME_EN')}</th>
                  <th style={{ borderBottom: '1px solid black' }}>{t('TREATMENT_PLAN_TYPE.TABLE.CELL.STATUS')}</th>
                  <th style={{ borderBottom: '1px solid black' }}>{t('TREATMENT_PLAN_TYPE.TABLE.CELL.UPDATED_BY')}</th>
                </tr>
              </thead>
              <tbody>
                {exportData?.length === 0 &&
                  <tr>
                    <td colSpan={5} style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100%' }}>{t('NOT_FOUND')}</td>
                  </tr>
                }
                {exportData.map((data: any, index: number) => (
                  <tr key={index}>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{index + 1}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.treatmentPlanTypeName || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.treatmentPlanTypeNameEn || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100px' }}>{t(`STATUS.${data?.status}`) || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      <span>{data?.updatedBy || '-'}</span>
                      <span>{dateTimeToView(data?.updatedAt) || '-'}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
